import { motion } from "framer-motion";
import { ArrowUpRight, Clock, MoonStar } from "lucide-react";
import { TREATMENTS } from "./data";

const EASE = [0.16, 1, 0.3, 1];
const SPANS = ["lg:col-span-2", "", "", "", "", "", "lg:col-span-2"];

export default function Treatments({ onEnquire }) {
  return (
    <section id="treatments" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: EASE }}
            className="lg:col-span-7"
          >
            <p className="text-xs uppercase tracking-[0.25em] text-clay font-semibold mb-6">
              The Treatment Menu
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-snug text-ink">
              Seven treatments.
              <span className="italic text-clay"> One honest plan.</span>
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: EASE }}
            className="lg:col-span-5 text-sm text-ink/60 leading-relaxed"
          >
            No prices online, no bundles you'll never use. Every plan begins
            with a proper consultation — then we prescribe only what your skin
            actually needs.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TREATMENTS.map((t, i) => (
            <motion.article
              key={t.id}
              data-testid={`treatment-card-${t.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: EASE }}
              className={`group bg-[#F5F0E8] border border-[#E5DDD0] rounded-3xl p-8 lg:p-10 flex flex-col hover:border-clay/50 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(192,108,76,0.35)] transition-all duration-500 ${SPANS[i]}`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="text-xs tracking-[0.25em] text-clay font-semibold uppercase">
                  {t.tag}
                </span>
                <span className="font-serif text-3xl font-light text-ink/20 group-hover:text-clay/50 transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-serif text-2xl sm:text-3xl font-medium tracking-tight text-ink mb-4">
                {t.name}
              </h3>
              <p className="text-sm text-ink/60 leading-relaxed mb-8 flex-1">
                {t.desc}
              </p>
              <div className="flex items-center gap-6 text-xs text-ink/50 mb-8">
                <span className="inline-flex items-center gap-1.5">
                  <Clock size={13} className="text-sage" />
                  {t.duration}
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <MoonStar size={13} className="text-gold" />
                  Downtime: {t.downtime}
                </span>
              </div>
              <button
                data-testid={`treatment-enquire-button-${t.id}`}
                onClick={() => onEnquire(t.name)}
                className="inline-flex items-center gap-2 self-start text-sm font-semibold text-ink underline decoration-clay decoration-2 underline-offset-8 hover:text-clay transition-colors duration-300"
              >
                Enquire about this treatment
                <ArrowUpRight
                  size={16}
                  className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"
                />
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
